import React, { ReactNode, useState } from 'react';

interface ExpandProviderProps {
  children: ReactNode;
}

type IsAllExpanded = {
  state: boolean;
  timestamp: number;
};

type ExpandContextValue = {
  collapseAll: () => void;
  expandAll: () => void;
  resetAll: () => void;
  isAllExpanded: IsAllExpanded | undefined;
};

const ExpandContext = React.createContext<ExpandContextValue>({} as ExpandContextValue);
export const useExpand = () => React.useContext(ExpandContext);

const ExpandProvider = ({ children }: ExpandProviderProps) => {
  const [isAllExpanded, setIsAllExpanded] = useState<IsAllExpanded>();

  const expandAll = () => {
    setIsAllExpanded({ state: true, timestamp: Date.now() });
  };

  const collapseAll = () => {
    setIsAllExpanded({ state: false, timestamp: Date.now() });
  };

  const resetAll = () => {
    setIsAllExpanded(undefined);
  };

  return (
    <ExpandContext.Provider value={{ expandAll, collapseAll, resetAll, isAllExpanded }}>
      {children}
    </ExpandContext.Provider>
  );
};

export default ExpandProvider;
